import { createClient } from '@supabase/supabase-js';
import { validateEnvironment } from '../utils/validateEnv';

// Check environment variables
const env = validateEnvironment();

// Create a placeholder client if env vars are missing to prevent crashes
let supabase: ReturnType<typeof createClient>;

if (env.hasSupabase) {
  // Get environment variables - defensive check for test environments
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL?.trim();
  const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY?.trim();

  // Additional safety check for test environments
  if (!supabaseUrl || !supabaseAnonKey) {
    console.warn('⚠️ Environment validation passed but variables are missing in runtime');
    supabase = createClient('https://placeholder.supabase.co', 'placeholder-key');
  } else {
    // Validate URL format
    if (!supabaseUrl.startsWith('https://') || !supabaseUrl.includes('.supabase.co')) {
      console.error('Invalid Supabase URL format:', supabaseUrl);
    }

    // Configure client with increased row limits for large telemetry datasets
    supabase = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
      global: {
        headers: {
          Prefer: 'return=representation',
          'Range-Unit': 'items',
        },
      },
    });
  }
} else {
  console.warn('⚠️ Supabase environment variables not set.');
  console.warn('Missing variables:', env.missing.join(', '));
  console.warn('Authentication features are disabled.');
  console.warn('To enable authentication:');
  console.warn('1. Create a Supabase project at https://supabase.com');
  console.warn('2. Create a .env.local file with:');
  console.warn('   REACT_APP_SUPABASE_URL=your-project-url');
  console.warn('   REACT_APP_SUPABASE_ANON_KEY=your-anon-key');

  // Create a dummy client that won't crash but won't work either
  supabase = createClient('https://placeholder.supabase.co', 'placeholder-key');
}

export { supabase, env };

// Database types (we'll expand these as we build features)
export interface Profile {
  id: string;
  email: string;
  full_name?: string;
  avatar_url?: string;
  role: 'student' | 'parent' | 'coach' | 'admin';
  created_at: string;
  updated_at: string;
}
